import { WorkingScheduleFormType } from 'components/working-schedules/WorkingScheduleForm';

export const updateWorkingScheduleInitialValues: Partial<WorkingScheduleFormType> = {};
